import Flex from '@eversports/react-components/primitives/Flex'
import Skeleton from '@eversports/react-components/primitives/Skeleton'

const SkeletonAddons = () => (
  <Flex flexDirection="column" verticalSpacing="default">
    <Skeleton variant="text" height="24px" width="182px" />
    <Flex flexDirection="column" verticalSpacing="dense">
      <Flex horizontalSpacing="default">
        <Skeleton variant="circular" width="30px" height="30px" />
        <Skeleton variant="text" width="182px" />
      </Flex>
      <Skeleton variant="rectangular" height="35px" />
      <Skeleton variant="rectangular" height="35px" />
    </Flex>
    <Flex flexDirection="column" verticalSpacing="dense">
      <Flex horizontalSpacing="default">
        <Skeleton variant="circular" width="30px" height="30px" />
        <Skeleton variant="text" width="182px" />
      </Flex>
      <Skeleton variant="rectangular" height="35px" />
      <Skeleton variant="rectangular" height="35px" />
    </Flex>
  </Flex>
)

export default SkeletonAddons
